import React from 'react';
import { ButtonProps } from '@dotcom/crown-ui';

export type GroupRole = 'listbox' | 'tablist';

export enum ButtonGroupVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export type ButtonGroupProps = {
  /** An override for the default active class */
  activeClassOverride?: string;
  /** Additional CSS class to add for styling */
  addClass?: string;
  /** Aria Label that describes the group of buttons */
  ariaLabel: string;
  /** Buttons to be displayed inside the ButtonGroupProps */
  children: React.ReactElement<ButtonProps>[];
  /** Default index to show as clicked */
  defaultClickedIndex?: number;
  /** Controlled index to show as clicked */
  selectedIndex?: number;
  /** Fires when a Button is clicked */
  onIndexChange?: (index: number) => void;
  /** Role of the wrapping div containing the buttons. For instance, listbox (with role="option" on it's children) or tablist (with role="tab" on it's children) */
  groupRole?: GroupRole;
  /* The variant of the button group */
  variant?: ButtonGroupVariant;
};
